var _rect, _g, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSlotGamesIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 181,
    height: 180,
    viewBox: "0 0 181 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1003_26604)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1003_26604",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 181,
    height: 180
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.333008,
    width: 180,
    height: 180,
    fill: "#FEF6FA"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1003_26604)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 90.833,
    cy: 140,
    rx: 72.5,
    ry: 30,
    fill: "#FEF6FA"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1003_26604)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.45 35H45.2158C39.8849 35 35.5479 39.3371 35.5479 44.668V113.418C35.5479 118.749 39.8849 123.086 45.2158 123.086H135.45C140.781 123.086 145.118 118.749 145.118 113.418V44.668C145.118 39.3371 140.781 35 135.45 35Z",
    fill: "url(#paint0_linear_1003_26604)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.761 140.868C113.368 142.932 111.82 145 109.669 145H70.9971C68.8456 145 67.2983 142.932 67.9053 140.868L73.1354 123.086H107.531L112.761 140.868ZM104.298 41.4453V99.4531H76.3682V41.4453H104.298ZM97.4246 54.3359H83.2414C81.4617 54.3359 80.0188 55.7788 80.0188 57.5586C80.0188 59.3384 81.4617 60.7812 83.2414 60.7812H92.4877L83.1413 82.043C82.425 83.6724 83.1654 85.5738 84.7945 86.2901C86.4239 87.0064 88.3253 86.266 89.0416 84.6369L100.375 58.8556C101.311 56.7256 99.7509 54.3359 97.4246 54.3359ZM138.673 44.668V99.4531H110.743V41.4453H135.45C137.227 41.4453 138.673 42.891 138.673 44.668ZM131.8 54.3359H117.616C115.837 54.3359 114.394 55.7788 114.394 57.5586C114.394 59.3384 115.837 60.7812 117.616 60.7812H126.863L117.516 82.043C116.8 83.6724 117.54 85.5738 119.17 86.2901C120.799 87.0064 122.7 86.266 123.417 84.6369L134.75 58.8556C135.686 56.7256 134.126 54.3359 131.8 54.3359ZM69.9229 41.4453V99.4531H41.9932V44.668C41.9932 42.891 43.4388 41.4453 45.2158 41.4453H69.9229ZM63.0496 54.3359H48.8664C47.0867 54.3359 45.6438 55.7788 45.6438 57.5586C45.6438 59.3384 47.0867 60.7812 48.8664 60.7812H58.1127L48.7663 82.043C48.05 83.6724 48.7904 85.5738 50.4196 86.2901C52.0489 87.0064 53.9503 86.266 54.6666 84.6369L65.9998 58.8556C66.9359 56.7256 65.3759 54.3359 63.0496 54.3359Z",
    fill: "url(#paint1_linear_1003_26604)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1003_26604",
    x1: 90.333,
    y1: 35,
    x2: 90.333,
    y2: 123.086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F79F2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4D4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1003_26604",
    x1: 50.248,
    y1: 136.158,
    x2: 127.307,
    y2: 64.2145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF6F7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1003_26604"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    fill: "white",
    transform: "translate(0.333008)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1003_26604"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 110,
    fill: "white",
    transform: "translate(35.333 35)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlotGamesIcon);
export default __webpack_public_path__ + "static/media/slot-games-icon.4073c9444be0bc7bfb58823dfb6407a3.svg";
export { ForwardRef as ReactComponent };